export const SUPPORT_LINK = 'https://support.pigello.io';
